module.exports = __webpack_public_path__ + "static/media/level-up-alt.212b3034.svg";